import linspace from 'linspace';
import CreateNormalDist from 'distributions-normal';

const getLinearX = (n, low = 0.00, high = 1.00) => {
  const x = linspace(low, high, n);
  x[x.length - 1] = 0.9999;
  return x;
};

const getDistNormalMuSigma = (mu, sigma, n = 100) => {
  const cdf = getLinearX(n);
  const normal = CreateNormalDist().mean(mu).variance(sigma ** 2);
  const X = normal.inv(cdf).filter((i) => { return i >= 0; });
  const pdf = normal.pdf(X);
  return {
    X,
    pdf,
    cdf,
    mean: normal.mean(),
    median: normal.median(),
    variance: normal.variance(),
  };
};

const getDistNormalMeanStddev = (mu, sigma, n = 100) => {
  return getDistNormalMuSigma(mu, sigma, n);
};

const getDistNormalPercentile = (fifth, ninetyFifth, n = 100) => {
  const mu = (ninetyFifth - fifth) / 2;
  const sigma = (ninetyFifth - mu) / 1.64485;
  return getDistNormalMuSigma(mu, sigma, n);
};

export {
  getDistNormalMeanStddev,
  getDistNormalPercentile,
};
